import { TRACK_ID, Track } from '@hugendubel/tracking_client';
import { Toaster } from '@hugendubel/react-basic';
import { WS } from '../ws/WS';
import { WsBonusShopHistory } from '../ws/result/WsBonusShopHistory';
import { Store } from '../store';

const load = (): Promise<void> =>
    WS.loadBonusPointHistory()
        .then(({ transactions }: WsBonusShopHistory) => Store.set({ transactions }))
        .catch((error: Error) => {
            Track.error(TRACK_ID('2018-09-10 10:33:31'), 'Could not load point history: ' + error.message);
            Toaster.open(
                process.env.IS_HUDU
                    ? 'page.PointHistory.error.loadingFailed.hudu'
                    : 'page.PointHistory.error.loadingFailed.eBook'
            );
        });

export const BonusPointHistoryService = { load };
